var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-content inner-body-block"},[_c('h1',[_vm._v("Документы")]),_vm._v(" "),_c('div',{staticClass:"documents"},_vm._l((_vm.documents),function(item){return _c('nuxt-link',{key:item.link,attrs:{"to":item.link}},[_vm._v(_vm._s(item.name))])}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }